import { render, staticRenderFns } from "./JStyleDemo.vue?vue&type=template&id=4d816452"
import script from "./JStyleDemo.vue?vue&type=script&lang=js"
export * from "./JStyleDemo.vue?vue&type=script&lang=js"
import style0 from "./JStyleDemo.vue?vue&type=style&index=0&id=4d816452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports